import { ISnotrRoute } from '..';

export default [
  {
    path: '/warehouse/patches/new',
    name: 'WarehousePatchNew',
    meta: {
      title: 'TabTitle.newWarehousePatch',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/warehouse-patch-new.vue'),
  },
  {
    path: '/warehouse/patches/:id',
    name: 'WarehousePatchEdit',
    meta: {
      title: 'TabTitle.editWarehousePatch',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/warehouse-patch-edit.vue'),
    props: route => ({
      warehousePatchId: route.params.id,
    }),
  },
  {
    path: '/warehouse/patches',
    name: 'WarehouseList',
    meta: {
      title: 'TabTitle.warehouse',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/Warehouse/WarehousePatchList.vue'),

  },
  {
    path: '/warehouse',
    name: 'Warehouse',
    meta: {
      title: 'TabTitle.warehouse',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/warehouse.vue'),
  },
  {
    path: '/warehouse/new-checkpoint',
    name: 'CheckpointPatchNew',
    meta: {
      title: 'TabTitle.newCheckpointPatch',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/checkpoint-patch-new.vue'),
  },
] as ISnotrRoute[];
